export default __webpack_public_path__ + "static/media/welcome-costsavings.e7e4e4f2.png";